import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { VigenciaCampanhaFormControlComponent } from './vigencia-campanha-form-control-radio.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        VigenciaCampanhaFormControlComponent
    ],
    exports: [
        VigenciaCampanhaFormControlComponent
    ]
})
export class VigenciaCampanhaFormControlModule { }
